import { DefaultRootState } from 'react-redux';

import { selectResumeEditorOpenedType } from 'src/models/applicant/resume/editor/store/selectors';

export const selectResumeEditorOpenedEducationLevel = selectResumeEditorOpenedType('educationLevel');

export const selectResumeEditorEducationLevel = ({ resumeEditor }: DefaultRootState): string | undefined =>
    resumeEditor.fields.educationLevel;
